import httpClient from '../httpClient';

const post = async (data) => {
  return await httpClient.post(`/term_legal_validation_experience/`, data);
};

const getAllByValidation = async (validation_id) => {
  return await httpClient.get(
    `/term_legal_validation_experience/${validation_id}`,
  );
};

export { post, getAllByValidation };
